// useErrorMessageMapping.ts
import { useCallback } from "react";
import uniq from "lodash-es/uniq";
import { convertToAPIErrors } from "./convertToAPIErrors";
import { useTranslation } from "react-i18next";

export type APIError = {
  key: string;
  source: string;
  message: string;
};

export type FieldErrorMessages = { [fieldName: string]: string[] };

export type FormErrorsState = {
  errorMessages: string[];
  fieldErrorMessages: FieldErrorMessages;
  globalErrorMessages: string[];
};

export const useErrorMessageMapping = () => {
  const { t } = useTranslation()
  return useCallback(
    async (error: APIError[] | Response | Error, knownFields: string[] = []): Promise<FormErrorsState> => {
      const apiErrors = await convertToAPIErrors(error, t);

      const errorMessages = uniq(apiErrors.map((e) => e.message));

      const fieldErrorMessages = apiErrors
        .filter((e) => knownFields.includes(e.source))
        .reduce<FieldErrorMessages>((acc, e) => {
          acc[e.source] = uniq([...(acc[e.source] ?? []), e.message]);
          return acc;
        }, {});

      const globalErrorMessages = apiErrors
        .filter((e) => !knownFields.includes(e.source))
        .map((e) => e.message);

      return {
        errorMessages,
        fieldErrorMessages,
        globalErrorMessages,
      };
    },
    []
  );
};